// ¿De dónde llegó la clienta al catálogo? (sql/104)
// Los enlaces pueden traer ?o=<origen> (o utm_source). Se recuerda en la
// pestaña mientras navega para guardarlo en el pedido aunque ya no esté en la URL.

const CLAVE = 'kontrol_origen_catalogo';
const FORMATO = /^[a-z0-9_-]{1,30}$/;

export const ORIGENES = [
  { clave: 'bio', etiqueta: 'Bio de Instagram', icono: '🔗' },
  { clave: 'historia', etiqueta: 'Historia', icono: '📲' },
  { clave: 'post', etiqueta: 'Post o reel', icono: '🖼️' },
  { clave: 'whatsapp', etiqueta: 'WhatsApp', icono: '💬' },
  { clave: 'anuncio', etiqueta: 'Anuncio', icono: '📣' },
];

// Orígenes que el catálogo detecta solo (cuando el enlace no trae etiqueta):
// por la app donde se abrió (Instagram/Facebook/TikTok) o la página de donde vino.
export const ORIGENES_DETECTADOS = [
  { clave: 'instagram', etiqueta: 'Instagram', icono: '📸' },
  { clave: 'facebook', etiqueta: 'Facebook', icono: '👍' },
  { clave: 'tiktok', etiqueta: 'TikTok', icono: '🎵' },
  { clave: 'google', etiqueta: 'Google', icono: '🔎' },
  // No se detecta: lo ponen los mensajes de seguimiento que se mandan desde Pedidos.
  { clave: 'seguimiento', etiqueta: 'Seguimiento de pedido', icono: '🔁' },
  // Lo ponen los mensajes de la Campaña de recompra (Clientes).
  { clave: 'recompra', etiqueta: 'Campaña de recompra', icono: '💌' },
];

export const normalizarOrigen = (v) => {
  const o = String(v || '').trim().toLowerCase();
  return FORMATO.test(o) ? o : null;
};

export function etiquetaOrigen(clave) {
  if (!clave) return { etiqueta: 'Sin etiqueta', icono: '❔' };
  return ORIGENES.find((o) => o.clave === clave) || ORIGENES_DETECTADOS.find((o) => o.clave === clave)
    || { etiqueta: clave, icono: '🏷️' };
}

// Sin etiqueta en el enlace: se deduce de la app que lo abrió o de la página
// anterior. WhatsApp abre el navegador normal y no deja rastro (queda sin etiqueta).
export function detectarOrigen() {
  try {
    const ua = navigator.userAgent || '';
    if (/Instagram/i.test(ua)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB|FBIOS|Messenger/i.test(ua)) return 'facebook';
    if (/musical_ly|BytedanceWebview|TikTok/i.test(ua)) return 'tiktok';
    const p = new URLSearchParams(window.location.search);
    if (p.get('fbclid')) return 'facebook';
    const ref = document.referrer ? new URL(document.referrer).hostname : '';
    if (!ref || ref === window.location.hostname) return null;
    if (/instagram\./i.test(ref)) return 'instagram';
    if (/facebook\.|fb\.me|messenger\./i.test(ref)) return 'facebook';
    if (/tiktok\./i.test(ref)) return 'tiktok';
    if (/google\./i.test(ref)) return 'google';
    if (/whatsapp\./i.test(ref)) return 'whatsapp';
    return null;
  } catch {
    return null;
  }
}

// Al abrir el catálogo: si el enlace trae origen, se guarda (el último gana).
export function capturarOrigen() {
  try {
    const p = new URLSearchParams(window.location.search);
    // La etiqueta del enlace manda; si no trae, lo que se detecte (sin pisar uno ya guardado).
    const o = normalizarOrigen(p.get('o') || p.get('utm_source'));
    if (o) sessionStorage.setItem(CLAVE, o);
    else if (!sessionStorage.getItem(CLAVE)) {
      const d = detectarOrigen();
      if (d) sessionStorage.setItem(CLAVE, d);
    }
  } catch { /* sin sessionStorage: se toma de la URL */ }
}

export function origenActual() {
  try {
    const p = new URLSearchParams(window.location.search);
    return normalizarOrigen(p.get('o') || p.get('utm_source')) || normalizarOrigen(sessionStorage.getItem(CLAVE)) || detectarOrigen();
  } catch {
    return detectarOrigen();
  }
}
